import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ConsultasService } from '@app/services/consultas.service';
import { RelatorioService } from '@app/services/relatorio.service';
import { UtilitarioService } from '@app/services/utilitario.service';
import { ToastrService } from 'ngx-toastr';
import { MetaVisaoMensalDTO } from './relatorio-meta-visao-mensal';
import { Area } from '@app/models/area';
import { AreaService } from '@app/services/area.service';

@Component({
  selector: 'app-meta-visao-mensal',
  templateUrl: './meta-visao-mensal.component.html',
  styleUrls: ['./meta-visao-mensal.component.scss']
})
export class MetaVisaoMensalComponent implements OnInit {
  relatorioMetaVisaoMensal: MetaVisaoMensalDTO[] = [];
  quantidadePorUnidadeArea: Map<string, Map<string, number>> = new Map<string, Map<string, number>>();

  pesquisando: boolean;
  showTable: boolean = false;

  anosLista: IdDescricao[] = [];
  mesesLista: IdDescricao[] = [];

  anoSelecionado: number;
  mesSelecionado: number;

  listaArea: Area[];

  constructor(
    private _relatorioService: RelatorioService,
    private _consultasService: ConsultasService,
    @Inject(ToastrService) public toastr: ToastrService,
    private areaService: AreaService
  ) {}


  ngOnInit() {
    this._consultasService.consultar('ANOSMETA').toPromise().then(data => {
      this.anosLista = data;
      this._selecionaAnoMaisRecente(data);
    });
    this.areaService.obterLista("", 1).toPromise()
    .then(data => {
          this.listaArea = data;
        },
        (erro) => {
          this.toastr.info("Busca de áreas não encontrou resultados");
        }
    );
    this.mesesLista = this._preencheMeses();
    this._selecionaMesAtual();
  }

  private _selecionaAnoMaisRecente(data: any) {
    this.anoSelecionado = this.anosLista[data.length - 1].Id;
  }

  private _selecionaMesAtual() {
    this.mesSelecionado = this.mesesLista[new Date().getMonth()].Id;
  }

  private _preencheMeses(): IdDescricao[] {
    let listagemDeMeses: IdDescricao[] = [];
    listagemDeMeses.push(new IdDescricao(1, 'Janeiro'));
    listagemDeMeses.push(new IdDescricao(2, 'Fevereiro'));
    listagemDeMeses.push(new IdDescricao(3, 'Março'));
    listagemDeMeses.push(new IdDescricao(4, 'Abril'));
    listagemDeMeses.push(new IdDescricao(5, 'Maio'));
    listagemDeMeses.push(new IdDescricao(6, 'Junho'));
    listagemDeMeses.push(new IdDescricao(7, 'Julho'));
    listagemDeMeses.push(new IdDescricao(8, 'Agosto'));
    listagemDeMeses.push(new IdDescricao(9, 'Setembro'));
    listagemDeMeses.push(new IdDescricao(10, 'Outubro'));
    listagemDeMeses.push(new IdDescricao(11, 'Novembro'));
    listagemDeMeses.push(new IdDescricao(12, 'Dezembro'));

    return listagemDeMeses;
  }

  pesquisar() {
    
    if ((this.anoSelecionado??0) == 0 || (this.mesSelecionado??0) == 0) {
      this.toastr.warning('Selecione um ano e um mês', 'Atenção');
      return;
    }
    
    this.relatorioMetaVisaoMensal = [];
    this.pesquisando = true;
    this._relatorioService.obterRelatorioVisaoMensal(
      Number.parseInt(this.anosLista.find(ano => ano.Id === this.anoSelecionado).Descricao),
      this.mesSelecionado
    ).toPromise()
    .then((data) => {
      this.relatorioMetaVisaoMensal = data;
      if (this.relatorioMetaVisaoMensal.length === 0) {
        this.showTable = false;
        this.toastr.info("Busca não encontrou resultados");
      } else {
        this.relatorioMetaVisaoMensal.forEach(item => {
          this.quantidadePorUnidadeArea.set(item.UnidadeDescricao, new Map(Object.entries(item.QuantidadePorArea)));
        });
        this.showTable = true;
      }
    }, erro => {
      this.toastr.warning("Realize a pesquisa novamente.")
    }).finally(() => this.pesquisando = false);
  }

  @ViewChild('relatorioMensal') relatorio: ElementRef;
  public imprimir() {
    let conteudo = document.getElementById("metasvisaomensal").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, "Relatório de Metas (Visão Mensal)", this.montaImpressaoFiltros());
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();
    
    obtemDescricaoAdicionaMap('Ano', this.anosLista, this.anoSelecionado);
    obtemDescricaoAdicionaMap('Mês', this.mesesLista, this.mesSelecionado);
    
    function obtemDescricaoAdicionaMap(chave: string, listaItens: IdDescricao[], idItem: number){
      if(idItem){
        let valor = listaItens.find(x => x.Id === idItem).Descricao;
        objetoFiltros.set(chave, valor);
      } 
    }

    function parseDateAdicionaMap(tipoData: string, data: string){
      if(data && data.indexOf('-') >= 0){
        let dataPartes = data.split('-');
        let dataMontada = dataPartes[2] + '/' + dataPartes[1] + '/' + dataPartes[0];
        objetoFiltros.set(tipoData, dataMontada);
      }
    }

    function adicionaMapValido(chave: string, valor: any){
      if(valor){
        objetoFiltros.set(chave, valor.toString());
      }
    }

    let stringHtml = '';

    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    })
    return stringHtml;
  }

}